var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-success"},[_vm._m(0),_c('div',{staticClass:"tip"},[_vm._v("授权绑定成功")]),_c('div',{staticStyle:{"margin-top":"80px","text-align":"center"}},[_c('el-button',{staticStyle:{"width":"300px"},attrs:{"type":"primary"},on:{"click":_vm.jump}},[_vm._v("返回商城管理后台")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('i',{staticClass:"el-icon-success"})])
}]

export { render, staticRenderFns }